import React from 'react';
import { FaGithub, FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';


const HeaderSocials = () => {
    return (
        <div className='home__socials'>
            <a href='https://www.github.com/AnessZereg' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaGithub />
            </a>

      
            <a href='https://www.linkedin.com/in/aness-zereg-a08339228/' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaLinkedinIn />
            </a>

            <a href='https://www.facebook.com/AnessZereg' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaFacebookF />
            </a>

            <a href='https://www.twitter.com/AnessZereg' className='home__social-link' target='_blank' rel='noreferrer'>
                <FaTwitter />
            </a>
        </div>
    );
};

export default HeaderSocials;
